import { render, staticRenderFns } from "./ForbiddenNotManager.vue?vue&type=template&id=41e1d579"
import script from "./ForbiddenNotManager.vue?vue&type=script&lang=ts"
export * from "./ForbiddenNotManager.vue?vue&type=script&lang=ts"
import style0 from "./ForbiddenNotManager.vue?vue&type=style&index=0&id=41e1d579&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports